<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Rentang Jawaban Evaluasi Dosen'">
          <template v-slot:toolbar>
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')" />
          </template>
          <template v-slot:body>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="code4.search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="code4.headers" :items="code4.data" :search="code4.search">
                <template v-slot:item.action="{ item }">
                  <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal @click.native="openModal('Edit', item)"
                    dataTitleTooltip="Edit" />
                  <ButtonComponent colors="#EF4848" name="hapus" @click.native="deleteData(item.key)"
                    dataTitleTooltip="Hapus" />
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>

        <b-modal @ok="onSubmit" ok-title="Simpan" ok-variant="primary" no-enforce-focus cancel-title="Batal"
          cancel-variant="danger" id="modal" :title="`${statusModal} Bobot Jawaban`">
          <b-form>
            <b-form-group label="Bobot">
              <div class="col-lg">
                <vue-number v-model="request.bobot" v-bind="number" required minlenghth="4" :maxlength="5"
                  placeholder="Masukkan Bobot"></vue-number>
              </div>
            </b-form-group>
            <b-form-group label="Keterangan">
              <div class="col-lg">
                <b-form-input v-model="request.jawaban" type="text" required placeholder="Masukkan Keterangan">
                </b-form-input>
              </div>
            </b-form-group>
          </b-form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
  import KTCodePreview from "@/view/content/CardContent.vue";
  import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
  import axios from "axios";
  import {
    SET_BREADCRUMB
  } from "@/core/services/store/breadcrumbs.module";
  import {
    directive
  } from '@coders-tm/vue-number-format';

  export default {
    data() {
      return {
        request: {
          key: null,
          jawaban: null,
          bobot: null,
          nilai: null,
          status: null,
        },
        code4: {
          search: "",
          headers: [{
              text: "No",
              value: "no",
              align: "center",
              sortable: false
            },
            {
              text: "Nilai",
              value: "nilai",
              // align: "center"
            },
            {
              text: "Keterangan",
              value: "keterangan",
              // align: "center"
            },
            {
              text: "Rentang Nilai",
              value: "bobot",
              // align: "center"
            },
            {
              text: "Aksi",
              value: "action",
              align: "center"
            }
          ],
          data: []
        },
        statusModal: '',
        number: {
          decimal: ',',
          separator: '.',
          prefix: ' ',
          precision: 2,
          masked: false,
        },
      };
    },
    components: {
      KTCodePreview,
      ButtonComponent
    },
    directives: {
      number: directive,
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [{
        title: "Evaluasi"
      }, {
        title: "Master Bobot Jawaban"
      }, ]);
      this.getData();
    },
    methods: {
      async openModal(status, itemData = null) {
        this.statusModal = status
        // reset form
        this.request = {
          key: null,
          jawaban: null,
          bobot: null,
          nilai: null,
          status: null,
        }
        if (status == 'Edit') {
          this.request.key = itemData.key
          this.request.jawaban = itemData.keterangan
          this.request.bobot = itemData.bobot
          this.request.nilai = itemData.nilai
        }
      },

      async getData() {
        const result = await axios.get('penilaian-dosen/bobot-jawaban')
        if (this.code4.data) {
          this.code4.data = [];
        }
        result.data.data.map((res, index) => {
          let obj = {
            no: index + 1,
            nilai: this.ambilHurufPertamaSetiapKata(res.jawaban),
            keterangan: res.jawaban,
            bobot: res.bobot,
            key: res.key,
          };
          this.code4.data.push(obj);
          return res.length > index;
        });
      },

      ambilHurufPertamaSetiapKata(kalimat) {
        var kata = kalimat.split(" ");
        var hurufPertama = kata.map(function (kata) {
          return kata.charAt(0);
        });
        var hasil = hurufPertama.join("");

        return hasil;
      },

      async onSubmit() {
        const form = this.request
        if (form.key === null) {
          // store
          this.store(form)
        } else {
          // update
          this.update(form)
        }
      },

      async store(form) {
        try {
          const formData = new FormData()
          formData.append("bobot", form.bobot);
          formData.append("jawaban", form.jawaban);

          const result = await axios.post(`penilaian-dosen/bobot-jawaban/save/`, formData)
          this.refreshData(result, 'Store')

        } catch (err) {
          this.$swal(err);
        }
      },

      async update(form) {
        try {
          var formData = {
            bobot: form.bobot,
            jawaban: form.jawaban,
          };
          const result = await axios.put(`penilaian-dosen/bobot-jawaban/update/${form.key}`, formData)

          this.refreshData(result, 'Update')
        } catch (err) {
          this.$swal(`Failed`);
        }
      },

      async deleteData(key) {
        try {
          this.$swal({
            title: 'Are you sure?',
            text: 'You will not be able to recover this item!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
          }).then(async (result) => {
            if (result.value) {
              // User confirmed, so delete the item
              const result = await axios.delete(`penilaian-dosen/bobot-jawaban/delete/${key}`)
              this.refreshData(result, 'Delete')
            } else {
              // User canceled, so do nothing
            }
          })
        } catch (err) {
          this.$swal(`Failed`);
        }
      },

      refreshData(result, alert) {
        if (result.data.meta.code == 200) {
          this.$swal(`Success ${alert} Data`);
          this.getData()
        } else if (result.data.meta.code == 409) {
          this.$swal(`Failed, Data Already Exist!`);
          this.getData()
        } else if (result.data.meta.code == 403) {
          this.$swal(result.data.meta.message);
        } else {
          this.$swal(`Failed ${alert} Data`);
        }
      },
    }
  }
</script>
<style>
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  background-color: #3751E4;
  color: white;
  font-size: revert;
}
</style>